export default "__VITE_ASSET__CtbkVL$0__"